/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const BarLineChartO2C = ({
  datasets,
  chartData,
  title,
  height,
  width = "100%",
  minval,
}) => {
  const data = {
    labels: chartData.map((item) => item.month),
    datasets: datasets,
  };

  const options = {
    // indexAxis: indexAxis,
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 30,   // <-- adds space below legend
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          // padding: 20,
          font: {
            size: 8,
            weight: "bold",
          },
        },
      },        
      datalabels: {
        color: "black",
        textStrokeColor: "white",   // White border
        textStrokeWidth: 4,         // Thickness of border
        anchor: "end",
        align: "end",
        // rotation: 90,
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
      tooltip: {
        intersect: false,
      },    
    },
    scales: {
          x: {
            display: true,
            ticks: {
              display: true,
              font: {
                size: 10,
                // weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: false,
              // text: "Count",
            },
            ticks: {
              display: true,
              font: {
                size: 10,
                // weight: 'bold',
              },
            },
            grid: {
              display: false,
            },
          },
          y1: {
            beginAtZero: true,
            position: "right",
            min: minval,
            max: 120,
            title: {
              display: false,
              // text: "Percentage (%)",
            },
            ticks: {
              display: true,
              font:{
                size:10,
              },
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
              // drawOnChartArea: false,
            },
          },
        }
    };

  return (
    <div
      className="w-full p-2 bg-white rounded-xl"
      style={{ height: `${height}px`, width: `${width}%` }}
    >
      <Chart data={data} options={options} />
    </div>
  );
};

export default BarLineChartO2C;